import Link from "next/link";

import style from "./style.module.scss";

export const TagLine = ({
  title,
  href,
  type = "insights",
  className,
}: {
  title: string;
  href: string;
  type?: string;
  className?: string;
}) => {
  return (
    <div className={style.tagLine}>
      <Link href={`/${type}/${href}`} className={className} prefetch={false}>
        {title}
      </Link>
    </div>
  );
};
